import { render, staticRenderFns } from "./ManagersWalletTab.vue?vue&type=template&id=3bb78ad3"
import script from "./ManagersWalletTab.vue?vue&type=script&lang=js"
export * from "./ManagersWalletTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports